module.exports = __webpack_public_path__ + "img/hiper.e0869f8c.svg";